import produce from "immer";
import { OverlayAction, CLOSE_ALL_OVERLAYS, OPEN_MOBILE_MENU, OPEN_MEGA_DROPDOWN_MENU, OPEN_MODAL } from "./overlay.actions";
import OverlayRootState from "../models/redux-state.interface";

const initialState: OverlayRootState = {
    currentOverlay: undefined,
    modal: undefined,
    stickyLink: undefined,
    menu: undefined,
    subMenu: undefined,
    menuOpen: false,
    modalOpen: false,
};

export default (overlayState = initialState, action: OverlayAction): OverlayRootState => produce(overlayState, draft => {
    switch (action.type) {
        case OPEN_MOBILE_MENU: {
            draft.currentOverlay = "MOBILE_MENU";
            draft.menu = action.menu;
            draft.subMenu = action.subMenu;
            draft.menuOpen = true;
            break;
        }
        case OPEN_MEGA_DROPDOWN_MENU: {
            draft.currentOverlay = "MEGA_DROPDOWN_MENU";
            draft.menu = action.menu;
            draft.subMenu = action.subMenu;
            draft.menuOpen = true;
            break;
        }
        case OPEN_MODAL: {
            draft.currentOverlay = "MODAL";
            draft.modal = action.modal;
            draft.modalOpen = true;
            draft.stickyLink = action.stickyLink;
            break;
        }
        case CLOSE_ALL_OVERLAYS: {
            draft.currentOverlay = undefined;
            draft.modal = undefined;
            draft.menu = undefined;
            draft.subMenu = undefined;
            draft.menuOpen = false;
            draft.modalOpen = false;
            break;
        }
    }
});
